<div class="card px-4 md:px-8 lg:px-8 pt-7 md:pt-8 lg:pt-8 pb-8 md:pb-16 lg:pb-16 h-full ">
  @if(!isLoading) {
    <afcu-loading target=""/>
  }@else if (path.includes('cancel') || path.includes('information') || path.includes('newevent')){
    <router-outlet />
  } @else {
      <div [class]="'md:grid md:grid-cols-12 md:grid-rows-10 md:h-full md:w-full lg:grid-cols-12'">

        <div
          [class]="CssClass"
          class="grid row-span-10 gap-.5 md:pr-11">
          @if(!path.includes('splash')){
            <div class="flex flex-col gap-4 pb-4">
              @if(!path.includes('branches-location') && !path.includes('your-appointment')){
                <afcu-navigation/>
              }
  
              @if (origin !== 'queue' && origin !== 'kiosk' && !path.includes('check-in')) {
                <afcu-breadcrumbs class="col-span-12 row-start-2" [branchView]="branchView()" [appointment]="path.includes('your-appointment')"/>
              }
              <afcu-title/>
            </div>
          }
          <div class="grid row-start-2 row-span-10">
            <router-outlet />
          </div>
        </div>
      @if (!path.includes('your-appointment') || this.origin === 'queue' || this.origin === 'check-in'){
        <div [class]="(path.includes('splash') || path.includes('check-in') || this.origin === 'queue' || this.origin === 'kiosk') ? 'h-full': 'h-fit'" class="col-span-3 row-span-10 col-start-10 rounded">
          @if(!path.includes('splash') && !path.includes('check-in') && this.origin !== 'queue' && this.origin !== 'kiosk'  && !path.includes('your-appointment') ){
            <afcu-branch [branchService]="schedulerService.branchSelected()" [target]="'service'"/>
          } @else if(path.includes('check-in') || this.origin === 'queue' || path.includes('your-appointment')) {
            @if(Settings.GLOBAL.kiosk_tower_ad.enabled) {
              <img class="hidden md:block bg-auto bg-no-repeat rounded" [src]="Settings.GLOBAL.kiosk_tower_ad.imageURL" [alt]="Settings.GLOBAL.kiosk_tower_ad.alt_text[textService.language().toLowerCase()]"/>
            }
          } @else if((path.includes('splash') && Settings.GLOBAL.kiosk_allow_device.enabled) && !isToken){
            <afcu-kiosk-side />
          } @else if(Settings.GLOBAL.kiosk_tower_ad.enabled) {
            <img class="hidden md:block bg-auto bg-no-repeat h-full rounded" [src]="Settings.GLOBAL.kiosk_tower_ad.imageURL" [alt]="Settings.GLOBAL.kiosk_tower_ad.alt_text[textService.language().toLowerCase()]"/>
          }
        </div>
      }
    </div>
  }
</div>